import { EEPlanObjectives } from "./Objectives/EEPlanObjectives"
import { WorkforceProfileBase } from "./WorkforceProfile/WorkforceProfileBase";
import { EEPlanBarriers } from "./Barriers/EEPlanBarriers";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import React from "react";
import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch } from "react-router-dom";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { useRecoilValue } from "recoil";
import { useRouteMatch } from "../../../Helpers/RouteMatcher";
import { AdditionalBase } from "./Additional/AdditionalBase";


export const EEPlan = () => {
    const scorecard = useRecoilValue(ScorecardAtom);

    const routes = [
        "/ee/scorecard/" + scorecard.scorecardId + "/eePlan/Objectives",
        "/ee/scorecard/" + scorecard.scorecardId + "/eePlan/Barriers",
        "/ee/scorecard/" + scorecard.scorecardId + "/eePlan/WorkforceProfileGoalsAndTargets",
        "/ee/scorecard/" + scorecard.scorecardId + "/eePlan/Additional"
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    return (

        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Employment Equity Plan
                </MDTypography>
            </MDBox>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Objectives" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Barriers" value={routes[1]} to={routes[1]} component={Link} />
                        <Tab label="Workforce Profile, Numerical Goals and Targets" value={routes[2]} to={routes[2]} component={Link}/>
                        <Tab label="Additional" value={routes[3]} to={routes[3]} component={Link}/>
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        <Route path={routes[0]}>
                            <EEPlanObjectives />
                        </Route>
                        <Route path={routes[1]}>
                            <EEPlanBarriers />
                        </Route>
                        <Route path={routes[2]}>
                            <WorkforceProfileBase />
                        </Route>
                        <Route path={routes[3]}>
                            <AdditionalBase />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}